































import BaseComponent from '@/components/base-component.vue';
import { ConflitoAgendaFiltros } from '@/interfaces/calendar';
import { listCrmCalendarConflicts } from '@/services/crm-calendar';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {},
  directives: {}
})
export default class CalendarConflictAlertDialog extends BaseComponent {
  @Prop()
  parms: ConflitoAgendaFiltros;

  maxWidth = 800;

  dialogFlag = false;

  list = [];

  public headers: any = [
    { text: 'Colaborador(es)', value: 'participantesConflito', sortable: false },
    { text: 'Período', value: 'periodoFmt', sortable: false },
    { text: 'Tipo', value: 'tipoDs', sortable: false },
    { text: 'Descrição', value: 'descricao', sortable: false }
  ];

  public $refs!: {
    form: HTMLFormElement;
  };

  mounted() {}

  @Watch('parms', { immediate: true })
  watchParms(p) {
    if (!p) {
      return;
    }
    this.loader.start("Consultando a agenda ...");
    listCrmCalendarConflicts(p).subscribe(
      (res) => {
        this.loader.stop();
        this.list = res;
        if (!res || !res.length) {
          this.save();
        } else {
          this.dialogFlag = true;
        }
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
        this.cancel();
      }
    );
  }

  cancel() {
    this.$emit('cancel');
  }

  save() {
    this.$emit('save');
  }
}
